"use client";

import { useEffect } from "react";
import { installErrorHandlers } from "@/utils/error-handler";

export function ErrorHandlerInstaller() {
  useEffect(() => {
    installErrorHandlers();
  }, []);

  return null;
}
